import React, { useEffect } from 'react'
import CreateMle from './CreateMle'
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom/cjs/react-router-dom.min';
import { bindActionCreators } from 'redux';
import { fetchMerchantLegalEntityDetailsRequest } from './redux/merchantLegalEntity.actions';

const EditViewMle = ({
    actions,
    history, 
    permissions,
    formData,
    formEvents,
    uniqueIdentifier,
    merchantLegalEntityData
}) => {
    const {redirect} = merchantLegalEntityData;
    const { location } = history;
    const locationArray = location.pathname.split('/');
    const merchantId = locationArray[4];
    if (redirect === 'error' || !merchantId) {
        history.push('/mle-onboarding');
    }
    useEffect(() => {
        if (merchantId) {
            
            const entityCode = merchantId;
            if (entityCode) {
                actions.fetchMerchantLegalEntityDetailsRequest({ entityCode });
            }
        }
    }, [merchantId]);
    
    // useEffect(()=> {}, [redirect])
    if (!redirect) {
        return <></>
    }
    // useEffect(()=> {
    //         if (merchantLegalEntityData.redirect) {
    //             history.push(merchantLegalEntityData.redirect);
    //         }
    
    //         return () => actions.removeRedirectKey();
    //     }, [merchantLegalEntityData.redirect]);

  return (
    <CreateMle
        history={history}
        permissions={permissions}
        formData={formData}
        formEvents={formEvents}
        uniqueIdentifier={uniqueIdentifier}
        isUpdate={true} // passing true as we are editing an existing MLE
    />
  )
}


const mapStateToProps = ({ auth, merchantLegalEntityData }) => ({
    auth,
    merchantLegalEntityData,
});

const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators(
        {
            fetchMerchantLegalEntityDetailsRequest
        },
        dispatch
    ),
});

export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(EditViewMle)
);
